import { create } from 'zustand';
import { getInvitations } from '../../../api/api';

export const useInvitationsStore = create((set) => ({
  data: [],
  isLoading: false,
  error: null,

  fetchInvitations: async () => {
    set({ isLoading: true, error: null });
    getInvitations(
      (data) => {
        set({ data, isLoading: false });
      },
      (err) => {
        set({ error: err, isLoading: false });
      }
    );
  },
}));
